export const initialStateOptions = (sort = 'createdIn', limit = 10) => ({
  page: 1,
  limit,
  offset: 0,
  filter: '',
  sort,
  sortDesc: true,
});

export default {
  initialStateOptions,
};
